// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__1joV4","buttons":"PendingPaymentAlert_buttons__1NcV8"};